import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query · Admin
 *
 * Admin 화면은 실시간성이 중요한 곳(Dashboard KPI, Incident 인박스)이 많으므로
 * staleTime은 짧게(15s) · refetchOnWindowFocus는 true로 기본화.
 * 개별 쿼리에서 override 권장.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
